import React from 'react';
import { ConfigProvider, Flex, Modal, notification } from 'antd';
import Battery100Icon from '../../assets/icons/Battery100';
import ChartBarIcon from '../../assets/icons/ChartBarIcon';
import Wifi from '../../assets/icons/Wifi';
import BellSlashIcon from '../../assets/icons/BellSlashIcon';
import ChevronLeftIcon from '../../assets/icons/ChevronLeftIcon';
import EnveloppeIcon from '../../assets/icons/EnveloppeIcon';
import PhoneIcon from '../../assets/icons/PhoneIcon';
import UserPlus from '../../assets/icons/UserPlus';
import User from '../../assets/icons/User';
import { LinkedinFilled } from '@ant-design/icons';
import DocumentDuplicateIcon from '../../assets/icons/DocumentDuplicateIcon';

const Header = () => {
  const getCurrentTime = () => {
    const now = new Date();
    return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
  };

  return (
    <Flex justify='space-between' align='center' style={{ padding: '1rem', color: '#ffffff', width: '100%' }}>
      <Flex align='center' style={{ fontWeight: 700, textAlign: 'center', color: '#ffffff' }}>
        <p>{getCurrentTime()}</p>
        <BellSlashIcon className='ml-1 size-4 fill-white' />
      </Flex>
      <div style={{ backgroundColor: 'black', borderRadius: '9999px', width: '4.5rem', height: '1.25rem' }}></div>
      <Flex align='center' style={{ fontWeight: 700, textAlign: 'center', color: '#ffffff' }}>
        <Wifi className='size-4 fill-white' />
        <ChartBarIcon className='ml-1 size-4 fill-white' />
        <Battery100Icon className='ml-1 size-4 fill-white' />
      </Flex>
    </Flex>
  );
};

const UserProfile = () => {
  return (
    <Flex vertical align='center' justify='center' style={{ width: '100%', background: 'linear-gradient(0deg,rgba(40, 43, 50, 1) 0%, rgba(76, 79, 83, 1) 100%)', padding: '1rem', borderTopLeftRadius: '1rem', borderTopRightRadius: '1rem'}}>
      <div className='flex justify-between items-center w-full p-2'>
        <div className='bg-zinc-500 rounded-full w-6 h-6 flex items-center justify-center'>
          <ChevronLeftIcon className='size-4 fill-white' />
        </div>
        <div className='bg-zinc-500 rounded-full text-white h-6 text-center px-3 flex items-center justify-center'>
          <p className='text-xs'>Edit</p>
        </div>
      </div>
      <div className='flex flex-col items-center justify-center w-full p-4'>
        <div className='bg-zinc-500 rounded-full w-20 h-20 flex items-center justify-center'>
          <User className='size-14 fill-white' />
        </div>
        <p className='text-white text-2xl mt-2'>Louis Alleyne</p>
      </div>
      <div className='flex justify-around items-center gap-3 p-4'>
        <a href='mailto:louisalleynepro@gmail.com'>
          <div className='flex flex-col items-center rounded-lg p-2 w-16 bg-gray-700 hover:bg-gray-600 transition-colors'>
            <EnveloppeIcon className='size-4 fill-white' />
            <p className='text-white text-xs mt-1'>mail</p>
          </div>
        </a>
        <a href='tel:+33788572910'>
          <div className='flex flex-col items-center rounded-lg p-2 w-16 bg-gray-700 hover:bg-gray-600 transition-colors'>
            <PhoneIcon className='size-4 fill-white' />
            <p className='text-white text-xs mt-1'>call</p>
          </div>
        </a>
        <a href='https://www.linkedin.com/in/louis-alleyne-3a2027204/' target='_blank' rel='noopener noreferrer'>
          <div className='flex flex-col items-center rounded-lg p-2 w-16 bg-gray-700 hover:bg-gray-600 transition-colors'>
            <LinkedinFilled style={{ color:'white' }} />
            <p className='text-white text-xs mt-1'>connect</p>
          </div>
        </a>
        <a 
          href='/assets/vcard.vcf' 
          download='Louis_Alleyne.vcf'
        >
          <div className='flex flex-col items-center rounded-lg p-2 w-16 bg-gray-700 hover:bg-gray-600 transition-colors'>
              <UserPlus className='size-4 fill-white' />
              <p className='text-white text-xs mt-1'>add</p>
          </div>
        </a>
      </div>
    </Flex>
  );
};

const Links = (api) => {
  return (
    <Flex vertical align='center' justify='center' style={{ width:'100%', padding:'3rem 1rem' }} className='p-4 h-76 gap-4'>
      <div className='bg-zinc-800 rounded-lg w-full flex p-2'>
        <div className='flex flex-col items-start w-2/3'>
          <p className='text-white text-left text-xs'>Phone</p>
          <p className='text-blue-400 text-left text-sm'>+33 7 88 57 29 10</p>
        </div>
        <div className='flex items-center justify-center w-1/3'>
          <button onClick={() => handleCopy('+33 7 88 57 29 10', 'Phone number', api)} className='flex rounded-lg cursor-pointer p-2 hover:bg-zinc-700 transition-colors'>
            <DocumentDuplicateIcon className='size-4 stroke-gray-400' />
            <span className='text-gray-400 text-xs ml-1'>Copy</span>
          </button>
        </div>
      </div>
      <div className='bg-zinc-800 rounded-lg w-full flex p-2'>
        <div className='flex flex-col items-start w-2/3'>
          <p className='text-white text-left text-xs'>Email</p>
          <p className='text-blue-400 text-left text-sm'>louisalleynepro@gmail.com</p>
        </div>
        <div className='flex items-center justify-center w-1/3'>
          <button onClick={() => handleCopy('louisalleynepro@gmail.com', 'Email', api)} className='flex rounded-lg cursor-pointer p-2 hover:bg-zinc-700 transition-colors'>
            <DocumentDuplicateIcon className='size-4 stroke-gray-400' />
            <span className='text-gray-400 text-xs ml-1'>Copy</span>
          </button>
        </div>
      </div>
      <div className='bg-zinc-800 rounded-lg w-full flex p-2'>
        <div className='flex flex-col items-start w-2/3'>
          <p className='text-white text-left text-xs'>LinkedIn</p>
          <p className='text-blue-400 text-left text-sm truncate w-full'>https://www.linkedin.com/in/louis-alleyne-3a2027204/</p>
        </div>
        <div className='flex items-center justify-center w-1/3'>
          <button onClick={() => handleCopy('https://www.linkedin.com/in/louis-alleyne-3a2027204/', 'LinkedIn, profile', api)} className='flex rounded-lg cursor-pointer p-2 hover:bg-zinc-700 transition-colors'>
            <DocumentDuplicateIcon className='size-4 stroke-gray-400' />
            <span className='text-gray-400 text-xs ml-1'>Copy</span>
          </button>
        </div>
      </div>
    </Flex>
  );
};

const handleCopy = (text, label) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    // Use clipboard API if available
    navigator.clipboard.writeText(text).then(() => {
      notification.success({
        message: `${label} copied to clipboard`,
        placement: 'top',
        duration: 1,
      });
    }).catch(() => {
      fallbackCopyTextToClipboard(text, label);
    });
  } else {
    // Fallback for unsupported devices
    fallbackCopyTextToClipboard(text, label);
  }
};

const fallbackCopyTextToClipboard = (text, label) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed'; // Prevent scrolling to the bottom of the page
  textarea.style.opacity = '0'; // Make it invisible
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  try {
    document.execCommand('copy'); // Use execCommand for older browsers
    notification.success({
      message: `${label} copied to clipboard`,
      placement: 'top',
      duration: 1,
    });
  } catch (err) {
    notification.error({
      message: `Failed to copy ${label}`,
      placement: 'top',
      duration: 1,
    });
  }

  document.body.removeChild(textarea); // Clean up
};

const Phone = ({ isModalOpen, setIsModalOpen }) => {

  const [api, contextHolder] = notification.useNotification();

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div style={{ pointerEvents: 'auto' }}>
      <div onClick={(e) => e.stopPropagation()}>
        <ConfigProvider
          theme={{
            components: {
              Modal: {
                headerBg: '#0D0D0D',
                contentBg: '#3D3D3D',
                colorIcon: '#FF0000',
              },
            },
          }}
        >
          {contextHolder} 
          <Modal
          centered
          open={isModalOpen}
          footer={null}
          onCancel={handleCancel}
          style={{ zIndex: 1050 }} 
          width='auto'
        >
          <Flex vertical align='center' justify='center' style={{ width: '20rem', height: 'auto', backgroundColor: '#0D0D0D', borderRadius: '1.5rem', border: '6px solid #C1AD9B' }} >
            <Header />
            <UserProfile />
            <Links api={api} />
          </Flex>
          </Modal>
        </ConfigProvider>
      </div>
    </div>
  );
}

export default Phone;